import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { HERO_MEDIA_HEIGHT_DESKTOP, HERO_MEDIA_HEIGHT_MOBILE } from '../constants/dimensions';
import { jsx as _jsx } from "react/jsx-runtime";
export function MediaSection({
  imageUrl,
  isMobile,
  title,
  videoId
}) {
  if (!imageUrl && !videoId) return null;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    blockSize: isMobile ? HERO_MEDIA_HEIGHT_MOBILE : HERO_MEDIA_HEIGHT_DESKTOP,
    inlineSize: "100%",
    justifyContent: "center",
    marginBlockEnd: isMobile ? '400' : '0',
    children: videoId ? /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      inlineSize: "100%",
      justifyContent: "center"
    }) : /*#__PURE__*/_jsx(Image, {
      alt: title,
      borderRadius: "400",
      inlineSize: "100%",
      objectFit: "contain",
      src: imageUrl
    })
  });
}